module.exports = __webpack_public_path__ + "img/arrow_swipe.3118f995.svg";